export const emailRegex = /^[a-zA-Z0-9_.-]*@/;
export const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{1,}$/;
export const passwordMinLength = 8;
export const dateLowerLimit = Object.freeze(new Date(2022, 0, 1));
